export default {
    //金蝶
    kingDiskWarehousePage: {
        method: 'POST',
        url: '/storage-command/thirdPartyWarehouse/page',
        name: '仓库管理列表分页'
    },
    kingDiskOrganization: {
        method: 'GET',
        url: '/storage-command/thirdPartyWarehouse/organization',
        name: '获取组织列表'
    },
    binding: {
        method: 'POST',
        url: '/storage-command/thirdPartyWarehouse/binding',
        name: '门店和机构绑定（切换机构）'
    },
    otherBinding: {
        method: 'POST',
        url: '/storage-command/other/binding',
        name: '门店机构（切换机构）和系统绑定'
    },
    shopBinding: {
        method: 'GET',
        url: '/storage-command/thirdPartyWarehouse/shopBinding',
        name: '获取门店绑定的机构'
    },
    warehouseDetail: {
        method: 'GET',
        url: '/storage-command/thirdPartyWarehouse/get/{id}',
        name: '获取仓库详情'
    },
    warehouseRefresh: {
        method: 'POST',
        url: '/storage-command/thirdPartyWarehouse/refresh',
        name: '仓库数据刷新'
    },
    kingDiskGoodsList: {
        method: 'POST',
        url: '/storage-command/thirdPartyGoods/page',
        name: '库存管理列表分页'
    },
    kingDiskMaterielList: {
        method: 'POST',
        url: '/storage-command/thirdPartyGoods/goods/page',
        name: '物料管理列表分页'
    },
    kingDiskGoodsRemind: {
        method: 'GET',
        url: '/storage-command/thirdPartyGoods/remind',
        name: '未进行默认售卖价报价提示（总店）'
    },
    kingDiskGoodsShopRemind: {
        method: 'GET',
        url: '/storage-command/thirdPartyGoods/shop/remind',
        name: '未进行售卖价报价提示（门店）'
    },
    kingDiskRemindUpdate: {
        method: 'PUT',
        url: '/storage-command/thirdPartyGoods/update',
        name: '批量修改物料报价'
    },
    kingDiskGoodsRefresh: {
        method: 'POST',
        url: '/storage-command/thirdPartyGoods/refresh',
        name: '库存数据刷新'
    },
    kingDiskGoodsRefreshGoodsInfo: {
        method: 'POST',
        url: '/storage-command/thirdPartyGoods/refresh/goodsInfo',
        name: '物料数据刷新'
    },
    kingDiskMaterielDetail: {
        method: 'GET',
        url: '/storage-command/thirdPartyGoods/goods/get',
        name: '物料管理-【物料详情】'
    },
    kingDiskGoodsDetail: {
        method: 'GET',
        url: '/storage-command/thirdPartyGoods/get',
        name: '库存管理-【库存详情】'
    },
    //自有
    warehouseAdd: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/add',
        name: '新增仓库管理'
    },
    selfWarehousePage: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/page',
        name: '仓库管理分页列表'
    },
    selfWarehouseAddType: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/addType',
        name: '添加商库类型'
    },
    selfWarehouseDelType: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/deleteType',
        name: '删除仓库类型'
    },
    selfWarehouseTypeList: {
        method: 'GET',
        url: '/storage-command/inventory/warehouse/typeList',
        name: '仓库类型列表'
    },
    selfWarehouseUpdate: {
        method: 'PUT',
        url: '/storage-command/inventory/warehouse/update',
        name: '修改仓库信息'
    },
    selfWarehouseDel: {
        method: 'DELETE',
        url: '/storage-command/inventory/warehouse/delete',
        name: '删除仓库'
    },
    selfWarehouseStoragePage: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/storage/page',
        name: '仓库存储分页列表'
    },
    getSelfGoodsCateList: {
        method: 'GET',
        url: '/storage-command/inventory/goods/goodsCateList',
        name: '商品类别列表'
    },
    getSelfGoodsUnitList: {
        method: 'GET',
        url: '/storage-command/inventory/goods/goodsUnitList',
        name: '商品单位列表'
    },
    getSelfMainWarehouse: {
        method: 'GET',
        url: '/storage-command/inventory/goods/getMainWarehouse',
        name: '获取门店对应的主仓库'
    },
    selfGoodsAdd: {
        method: 'POST',
        url: '/storage-command/inventory/goods/add',
        name: '商品入库'
    },
    addSelfGoogsCategory: {
        method: 'POST',
        url: '/storage-command/inventory/goods/addCategory',
        name: '新增商品分组'
    },
    addSelfGoodsUnit: {
        method: 'POST',
        url: '/storage-command/inventory/goods/addUnit',
        name: '新增商品单位'
    },
    selfGoodsPage: {
        method: 'POST',
        url: '/storage-command/inventory/goods/page',
        name: '物料管理列表'
    },
    selfWarehouseInfo: {
        method: 'GET',
        url: '/storage-command/inventory/warehouse/get',
        name: '仓库详情'
    },
    selfGoodsAddNum: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/addNum',
        name: '添加库存'
    },
    selfCategoryAndGoods: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/storage/goods',
        name: '仓库存储选择商品列表'
    },
    selfBatchGoodsAddNum: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/batch/addNum',
        name: '批量添加库存'
    },
    selfWarehouseExport: {
        method: 'POST',
        url: '/storage-command/inventory/warehouse/warehouse/export',
        name: '导出仓库存储导表'
    },
    selfGoodsDetail: {
        method: 'GET',
        url: '/storage-command/inventory/goods/get',
        name: '商品详情'
    },
    selfGoodsEdit: {
        method: 'PUT',
        url: '/storage-command/inventory/goods/update',
        name: '商品编辑'
    },
    selfCheckStoragePage: {
        method: 'POST',
        url: '/storage-command/inventory/goods/check/checkPage',
        name: '商品盘点'
    },
    selfCheckStorageConfirm: {
        method: 'PUT',
        url: '/storage-command/inventory/goods/check/confirm',
        name: '商品盘点-库存确认'
    },
    selfCheckPage: {
        method: 'POST',
        url: '/storage-command/inventory/goods/check/page',
        name: '库存盘点记录列表'
    },
    selfCheckInfo: {
        method: 'POST',
        url: '/storage-command/inventory/goods/check/checkInfo',
        name: '库存盘点详情'
    },
    selfDeleteCheck: {
        method: 'DELETE',
        url: '/storage-command/inventory/goods/check/deleteCheck/{id}',
        name: '删除库存盘点记录'
    },
    selfGoodsSalesOut: {
        method: 'POST',
        url: '/storage-command/inventory/goods/out/goodsSalesOut',
        name: '商品销售出库记录'
    },
    selfGoodsOtherOut: {
        method: 'POST',
        url: '/storage-command/inventory/goods/out/goodsOtherOut',
        name: '其它出库记录'
    },
    selfGoodsOutApply: {
        method: 'POST',
        url: '/storage-command/inventory/goods/out/goodsOutApply',
        name: '商品出库申请'
    },
    selfGoodsTemplate: {
        method: 'POST',
        url: '/storage-command/inventory/goods/goodsTemplate',
        name: '商品导入模板选择'
    },
    selfBatchGoodsImport: {
        method: 'POST',
        url: '/storage-command/inventory/goods/batchGoods',
        name: '批量商品excel导入'
    },
    selfSubmitTemplate: {
        method: 'POST',
        url: '/storage-command/inventory/goods/submitTemplate',
        name: '确认导入'
    },
    selfRemoveGoods: {
        method: 'POST',
        url: '/storage-command/inventory/goods/remove/removeGoods',
        name: '商品删除'
    },
    selfGoodsRemovePage: {
        method: 'POST',
        url: '/storage-command/inventory/goods/remove/page',
        name: '删除商品记录列表'
    },
    selfGoodsRemoveInfo: {
        method: 'GET',
        url: '/storage-command/inventory/goods/remove/removeInfo/{id}',
        name: '删除商品列表'
    },
    selfUploadRecord: {
        method: 'POST',
        url: '/storage-command/inventory/goods/upload/record',
        name: '批量商品导入记录'
    },
    selfGoodsInWarehouseRecord: {
        method: 'POST',
        url: '/storage-command/inventory/goods/goodsInWarehouse/record',
        name: '单个商品入库记录'
    },
    selfGoodsReturnedRecord: {
        method: 'POST',
        url: '/storage-command/inventory/goods/returned/record',
        name: '退货退款记录'
    },
    selfGoodsInWarehouseRecordExportAll: {
        method: 'POST',
        url: '/storage-command/inventory/goods/goodsInWarehouse/exportAll',
        name: '单个商品入库记录导出'
    },
    selfGoodsUploadRecordExportAll: {
        method: 'POST',
        url: '/storage-command/inventory/goods/upload/exportAll',
        name: '商品批量导入记录导出'
    },
    selfGoodsReturnedRecordExportAll: {
        method: 'POST',
        url: '/storage-command/inventory/goods/returned/exportAll',
        name: '退款退货记录导出'
    },
    selfGoodsDispatch: {
        method: 'POST',
        url: '/storage-command/inventory/goods/out/goodsDispatch',
        name: '商品调拨申请'
    },
    selfGoodsDispatchPage: {
        method: 'POST',
        url: '/storage-command/inventory/goods/out/platform/page',
        name: '调拨记录'
    },
    selfGoodsDispatchInfo: {
        method: 'GET',
        url: '/storage-command/inventory/goods/out/dispatchInfo/{id}',
        name: '商品调拨申请单'
    },
    selfGoodsDeleteDispatchRecord: {
        method: 'DELETE',
        url: '/storage-command/inventory/goods/out/deleteDispatchRecord/{id}',
        name: '删除调拨记录'
    },
    systemSwitching: {
        method: 'GET',
        url: '/storage-command/other/systemSwitching',
        name: '获取门店对应的所选系统'
    },
    sysIsUse: {
        method: 'GET',
        url: '/storage-command/other/isUse',
        name: '是否使用该系统'
    },
    kingDiskOfferPage: {
        method: 'POST',
        url: '/storage-command/thirdPartyGoods/offer/page',
        name: '物料管理-物料报价管理列表'
    },
    approveOutDetail: {
        method: 'GET',
        url: '/storage-command/inventory/goods/out/approveOut/{id}',
        name: '出库审批单查看'
    },
    selfGoodsGetInfo: {
        method: 'GET',
        url: '/storage-command/inventory/goods/get/info',
        name: '库存管理-【商品详情】'
    },
    sellGoods: {
        method: 'POST',
        url: '/storage-command/counter/storage/goods',
        name: '零售优惠-【商品选择】'
    }
}